import { Base, BaseDTO } from "./base";
import { AbstractControl } from "@angular/forms";
import { Tenants } from "./tenants";

export interface ZonesFilters{
    search?: string;
    tenant_id?: number;
}

export interface ZoneStatistic {
  id: number,
  name: string,
  totalQuantity: number,
  tenant_id?: number
}

export interface ZonesDTO extends BaseDTO{
    name: string;
    shipping_cost: number;
    radius: number;
    latitude: number;
    longitude: number;
    tenant_id: number;
    tenant: Tenants;
}

export class Zones extends Base{
    name: string;
    shipping_cost: number;
    radius: number;
    latitude: number;
    longitude: number;
    tenant_id: number;
    tenant: Tenants;



    constructor(source: ZonesDTO){
        super(source);
        if(source){
            this.name = source.name;
            this.shipping_cost = source.shipping_cost;
            this.radius = source.radius;
            this.latitude = source.latitude;
            this.longitude = source.longitude;
            this.tenant_id = source.tenant_id;
            this.tenant = source.tenant;
        }
    }

    toDTO(): ZonesDTO{
        let result: ZonesDTO = <ZonesDTO>super.toDTO();
        result.name = this.name;
        result.shipping_cost = this.shipping_cost;
        result.radius = this.radius;
        result.latitude = this.latitude,
        result.longitude = this.longitude
        result.tenant_id = this.tenant_id;

        return result;
    }

    static fromFormGroup(formGroup: AbstractControl, original?: Zones){
        const formModel = formGroup.value;
        let zones: Zones = new Zones(null);
        zones.name = formModel.name;
        zones.shipping_cost = formModel.shipping_cost;
        zones.radius = formModel.radius;
        zones.latitude = formModel.latitude;
        zones.longitude = formModel.longitude;
        zones.tenant_id = formModel.tenant_id;

        if (original) {
          zones.id = original.id;
        }
        return zones;
    }
}
